import { getAttribute } from "../../../../../../utils/utils/get-line-item-attribute.js";
import { getLineItemImageUrl } from "../../../../../../utils/utils/get-line-item-image-url.js";
import { getProductUrl } from "../../../../../../utils/utils/get-line-item-product-url.js";
import { getLocalizedString } from "../../../../../../utils/utils/get-localized-string.js";
import { getSharedProps } from "../../../../../../utils/utils/shared-line-item-data-mapper.js";
import { getBundledLineItemProductVariant } from "../../../utils/bundles/mappers/view/line-item/utils/bundles/get-bundled-line-item-product-variant.js";
import { findBundledLineItem } from "../../../utils/prescription-glasses/mappers/view/line-item/utils/prescription-glasses/find-bundled-line-item.js";
import { getBundledFrameInfo } from "../../../utils/prescription-glasses/mappers/view/line-item/utils/prescription-glasses/get-bundled-frame-info.js";
import { getBundledProductInfo } from "../../../utils/prescription-glasses/mappers/view/line-item/utils/prescription-glasses/get-bundled-product-info.js";
import { getLineItemCartDiscountDescription } from "../../../utils/prescription-glasses/mappers/view/line-item/utils/prescription-glasses/get-line-item-cart-discount-description.js";
import { getPrescription } from "../../../utils/prescription-glasses/mappers/view/line-item/utils/prescription-glasses/get-prescription.js";
const mapPrescriptionGlassesLineItem = (lineItemRaw, settings, intl) => {
  const mainBundleLineItem = lineItemRaw.bundleLineItems.find(
    (bundleLineItem) => bundleLineItem.isMainBundleLineItem
  );
  if (!mainBundleLineItem) {
    console.error(
      `None of the bundleLineItems have isMainBundleLineItem in LineItemBundle with id ${lineItemRaw.id}`
    );
    return null;
  }
  const lensTypeBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, "LensTypes");
  const lensPackageBundleLineItem = findBundledLineItem(
    lineItemRaw.bundleLineItems,
    "PrescriptionGlassPackages"
  );
  if (!lensTypeBundleLineItem || !lensPackageBundleLineItem) {
    console.error(
      `Either lensTypeBundleLineItem or lensPackageBundleLineItem are missing from LineItemBundle with id ${lineItemRaw.id}`
    );
    return null;
  }
  const prescriptionTypeDetails = lineItemRaw.typeDetails;
  const addOnBundleLineItem = findBundledLineItem(
    lineItemRaw.bundleLineItems,
    "PrescriptionGlassPackageOptions"
  );
  const shared = getSharedProps(lineItemRaw, mainBundleLineItem.legacyProduct, intl);
  const frame = getBundledFrameInfo(lineItemRaw, mainBundleLineItem, intl);
  const lensType = getBundledProductInfo(lensTypeBundleLineItem, intl);
  const lensPackage = getBundledProductInfo(lensPackageBundleLineItem, intl);
  const addOn = !!addOnBundleLineItem ? getBundledProductInfo(addOnBundleLineItem, intl) : void 0;
  const frameDiscount = frame.price?.discount || 0;
  const lensTypeDiscount = lensType.price?.discount || 0;
  const lensPackageDiscount = lensPackage.price?.discount || 0;
  const addOnDiscount = addOn?.price?.discount || 0;
  const totalProductDiscount = shared.quantity * (frameDiscount + lensTypeDiscount + lensPackageDiscount + addOnDiscount);
  const totalDiscount = shared.price.total.discount;
  const slug = getLocalizedString(
    intl.locale,
    mainBundleLineItem.legacyProduct.masterData.current.slug
  );
  const variant = getBundledLineItemProductVariant(mainBundleLineItem);
  return {
    ...shared,
    type: "prescription-glasses",
    name: frame.title,
    imageAlt: frame.title,
    frame,
    mainBundleItemPrice: frame?.price,
    imageUrl: getLineItemImageUrl(variant),
    erpId: getAttribute(variant, "erpId"),
    lensType,
    lensPackage,
    addOn,
    productUrl: getProductUrl(settings.productLinkFormatter, lineItemRaw, slug, intl.locale),
    prescription: getPrescription(prescriptionTypeDetails),
    ...!!totalDiscount ? {
      cartDiscount: {
        amount: totalDiscount - totalProductDiscount,
        description: getLineItemCartDiscountDescription(lineItemRaw, intl.locale)
      }
    } : {}
  };
};
export {
  mapPrescriptionGlassesLineItem
};
//# sourceMappingURL=prescription-glasses.js.map
